export const Background = () => (
  <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden data-testid="ambient-bg">
    <div className="absolute inset-0 grid-overlay" />
    <div className="absolute -top-48 -left-40 w-[620px] h-[620px] rounded-full blur-[150px] opacity-[0.16] bg-[#C026F5] animate-drift" />
    <div className="absolute -bottom-52 -right-40 w-[560px] h-[560px] rounded-full blur-[170px] opacity-[0.12] bg-[#6B21A8] animate-drift" style={{ animationDelay: "-9s" }} />
    <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[420px] h-[420px] rounded-full blur-[180px] opacity-[0.06] bg-[#C026F5]" />
  </div>
);
